import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogDescription,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";

export function SpecialInstructionDialog({
    open,
    onOpenChange,
    item = null,
    onSave
}) {
    const [instruction, setInstruction] = useState("");

    // Update instruction when item changes or dialog opens
    useEffect(() => {
        if (open && item) {
            setInstruction(item.SpecialInstructions || "");
        } else if (!open) {
            // Reset when dialog closes
            setInstruction("");
        }
    }, [open, item]);

    const handleSave = () => {
        if (onSave && item) {
            onSave(item.id, instruction.trim());
        }
        onOpenChange(false);
    };

    const handleCancel = () => {
        setInstruction(item?.SpecialInstructions || "");
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>Special Instructions</DialogTitle>
                    <DialogDescription>
                        {item ? `Add or edit special instructions for "${item.name}"` : "Add special instructions"}
                    </DialogDescription>
                </DialogHeader>

                <div className="py-4 space-y-4">
                    {item && (
                        <div className="space-y-2">
                            <Label htmlFor="itemName">Item Name</Label>
                            <div className="text-sm text-muted-foreground p-2 bg-muted rounded-md">
                                {item.name}
                                {item.SizeName && item.SizeName !== "-" && ` - ${item.SizeName}`}
                                {item.FlavourName && item.FlavourName !== "-" && ` (${item.FlavourName})`}
                            </div>
                        </div>
                    )}
                    <div className="space-y-2">
                        <Label htmlFor="instruction">Special Instructions</Label>
                        <Textarea
                            id="instruction"
                            placeholder="Enter special instructions for this item (e.g., No onions, Extra spicy, etc.)"
                            value={instruction}
                            onChange={(e) => setInstruction(e.target.value)}
                            rows={5}
                            className="resize-none"
                        />
                    </div>
                </div>

                <DialogFooter className="flex-col sm:flex-row gap-2">
                    <Button
                        variant="outline"
                        onClick={handleCancel}
                        className="w-full sm:w-auto"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSave}
                        className="w-full sm:w-auto"
                    >
                        Save
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

